<template>
  <!-- 自定义导出对话框 -->
  <el-dialog title="导出" :visible.sync="visible" width="1280px" :before-close="close">
    <div class="export-box">
      <div class="not-checked">
        <div class="tips">勾选区</div>

          <div class="box-checked">
            <div class="title">交易流水信息</div>
            <div class="checked-value">
              <div class="checkout-all">
                <el-checkbox :indeterminate="transactionIsIndeterminate" v-model="transactionCheckAll" @change="handleTransactionCheckAllChange">全选</el-checkbox>
              </div>
              <el-checkbox-group v-model="checkedTransactionList" @change="handleCheckedTransactionListChange">
                <el-checkbox v-for="transaction in transactions" :disabled="transaction.required" :label="transaction.name" :key="transaction.code" />
              </el-checkbox-group>
            </div>
          </div>
      </div>

      <div class="checked">
        <div class="tips">
          已选区 <span class="text">{{ selected.length }}</span>
        </div>
        <ul id="checked-drag" class="checked-group">
          <li v-for="item in selected" :key="item.code" :data-id="item.code" class="checked-group-item">
            <span>{{ item.name }}</span>
            <i v-if="!item.required" class="el-icon-close" @click="() => removeSelectedCheckboxItem(item.name)" />
          </li>
        </ul>
      </div>
    </div>

    <span slot="footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button type="primary" size="medium" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import API from '@/api'
import { Sortable } from 'sortablejs'
import _ from 'lodash'

export default {
  props: {
    parameter: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectLoading: false,
      userOptions: [], // 用户下拉框数据

      visible: false, // 自定义导出对话框 - 是否显示对话框

      // 导出字段中的英文标识对应关系
      correspondence: [],
      // 所有可导出的字段
      exportFields: [],
      selectedFieldsId: undefined,

      // 自定义导出对话框 - 账单信息
      transactionCheckAll: false, // 是否全选
      checkedTransactionList: [], // 当前已选项
      transactions: [], // 复选框数据源
      transactionIsIndeterminate: false, // 全选按钮的半选中样式

      selected: [], // 所有已选项
      showColumns: [],
      columnInfo: {}
    }
  },
  
  watch: {
    checkedTransactionList(value) {
      this.setSelected(value, 'transactions')
    }
  },
  methods: {
    // 显示弹窗
    show() {
      this.visible = true
      this.drag()
      this.getPublicSelectData()
    },

    /**
     * API 获取可导出字段的列表
     */
     async getPublicSelectData() {
      // let obj = {
      //   transactionInfo: [] // 交易流水信息
      // }
      try {
        let { data } = await API.getPublicSelectData({ type: 14, param: undefined })
        let { data: selectedFields } = await API.getExportFieldRecords(11)
        if (selectedFields) {
          this.selectedFieldsId = selectedFields.id
          selectedFields = JSON.parse(selectedFields.content)
        }
        if (data) {
          this.exportFields = data
          data.forEach((item) => {
            this.correspondence.push(item.fields)
            switch (item.name) {
              case '交易流水信息':
                if (item.fields && item.fields.length) {
                  this.transactions = item.fields
                  if (selectedFields) {
                    this.checkedTransactionList = [...selectedFields.transactionInfo]
                  } else {
                    item.fields.forEach((field) => {
                      if (field.required) {
                        this.checkedTransactionList.push(field.name)
                      }
                    })
                  }
                  if (this.checkedTransactionList.length === item.fields.length) {
                    this.transactionCheckAll = true
                    this.transactionIsIndeterminate = false
                  }
                  if (this.checkedTransactionList.length > 0 && this.checkedTransactionList.length < item.fields.length) {
                    this.transactionCheckAll = false
                    this.transactionIsIndeterminate = true
                  }
                } else {
                  this.transactions = []
                }
                break
            }
          })
          this.correspondence = this.correspondence.flat()
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },

    /**
     * 拖拽功能
     * 插件中文文档: https://www.itxst.com/sortablejs/neuinffi.html
     * 插件官方文档: https://github.com/SortableJS/Sortable/tree/master/plugins/MultiDrag
     */
     drag() {
      this.$nextTick(() => {
        let element = document.getElementById('checked-drag')
        if (element) {
          new Sortable(element, {
            handle: '.checked-group-item',
            draggable: '.checked-group-item',
            animation: 500,
            dataIdAttr: 'data-id'
          })
        }
      })
    },

    /**
     * 自定义导出对话框 - 账单信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
    handleTransactionCheckAllChange(value) {
      if (value) {
        this.checkedTransactionList = this.transactions.map((item) => item.name)
      } else {
        this.checkedTransactionList = []
        this.transactions.forEach((item) => {
          if (item.required) {
            this.checkedTransactionList.push(item.name)
          }
        })
      }
      if (this.checkedTransactionList.length && this.checkedTransactionList.length < this.transactions.length) {
        this.transactionIsIndeterminate = true
      } else {
        this.transactionIsIndeterminate = false
      }
    },

    /**
     * 自定义导出对话框 - 账单信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
    handleCheckedTransactionListChange(value) {
      let checkedCount = value.length
      this.transactionCheckAll = checkedCount === this.transactions.length
      this.transactionIsIndeterminate = checkedCount > 0 && checkedCount < this.transactions.length
    },

    /**
     * 自定义导出对话框 - 设置已勾选项
     * @param {Array} value 已勾选的复选框数组
     * @param {String} original 可选项数组
     */
    setSelected(value, original) {
      let selected = []
      let unchecked = []
      this[original].forEach((item) => {
        if (value.includes(item.name)) {
          selected.push(item.name)
        } else {
          unchecked.push(item.name)
        }
      })
      unchecked.forEach((item) => {
        this.selected.forEach((inside, index) => {
          if (item === inside.name) {
            this.selected.splice(index, 1)
          }
        })
      })
      this.correspondence.forEach((item) => {
        if (selected.includes(item.name)) {
          this.selected = Array.from(new Set([...this.selected, item]))
        }
      })
    },

    /**
     * 自定义导出对话框 - 删除某个已选的复选框
     * @param {String} value 当前删除的复选框的值
     */
    removeSelectedCheckboxItem(value) {
      if (this.checkedTransactionList.includes(value)) {
        this.checkedTransactionList = this.checkedTransactionList.filter((item) => item !== value)
        this.handleCheckedTransactionListChange(this.checkedTransactionList)
      }
      this.selected = this.selected.filter((item) => item.name !== value)
    },

    /**
     * 自定义导出 - 对话框保存按钮的事件
     */
    save() {
      if (this.selected.length === 0) {
        this.$message.warning('请选择需要导出的字段!')
        return
      }

      let ul = document.getElementById('checked-drag')
      let selected = []
      Array.from(ul.children).forEach((li) => {
        selected.push(li.getAttribute('data-id'))
      })

    /**
     * 深克隆
     */
      let parameter = _.cloneDeep(this.parameter)
      if (parameter.statusList === 1024) {
        parameter.statusList = [-2, -1, 0, 1, 2]
      } else {
        parameter.statusList = [parameter.statusList]
      }
      const params = {
        fileType: 2,
        taskType: 24,
        condition: JSON.stringify({
          searchContent: parameter,
          sortFields: [...selected]
        })
      }

      let obj = {
        transactionInfo: [] // 账单信息
      }

      this.exportFields.forEach((item) => {
        if (item.code === 'transaction_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.transactionInfo.push(field.name)
            }
          })
        }
      })

      API.setExportFieldRecords({ id: this.selectedFieldsId ? this.selectedFieldsId : undefined, type: 11, content: JSON.stringify(obj) })
        .then(() => {})
        .catch(() => {})

      API.dashboardImportExportFile(params)
        .then(() => {
          this.close()
          this.$message.success('操作成功，请到导入导出管理查看')
        })
        .catch(() => {
          this.$message.error('导出失败，请重新操作')
        })
    },

    /**
     * 自定义导出 - 对话框关闭的事件
     */
    close() {
      this.visible = false
      this.clear()
    },

    /**
     * 自定义导出 - 负责清除数据方法
     */
    clear() {
      this.correspondence = []
      this.transactionCheckAll = false
      this.checkedTransactionList = []
      this.transactionIsIndeterminate = false

      this.selected = []
    },
  }
}
</script>

<style lang="scss" scoped>
.export-box {
  display: flex;
  border-radius: 4px;
  border: 1px solid #e9e9e9;
  .not-checked,
  .checked {
    padding: 10px;
    .tips {
      line-height: 18px;
      margin-bottom: 10px;
      .text {
        color: #99c41c;
        font-weight: 700;
      }
    }
  }

  .not-checked {
    flex: 9;
    border-right: 1px solid #e9e9e9;
    /deep/.el-tabs__content {
      .el-tab-pane {
        overflow: auto;
      }
    }
    .checkout-all {
      margin-bottom: 10px;
    }
    .el-checkbox-group {
      .el-checkbox {
        width: 30%;
        margin-right: 22px !important;
        margin-bottom: 6px !important;
      }
    }
  }

  .checked {
    flex: 3;
    .checked-group {
      width: 100%;
      min-height: 280px;
      max-height: 480px;
      height: calc(100% - 28px);
      overflow-y: auto;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      .checked-group-item {
        display: flex;
        width: 100%;
        line-height: 28px;
        padding: 5px 8px;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #dcdfe6;
        user-select: none;
        cursor: move;
        span {
          max-width: 258px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        i {
          width: 25px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
          &:hover {
            color: #f56c6c;
          }
        }
      }
    }
  }
  .box-checked {
    margin: 20px 0;
    border: 1px solid #ccc;
    .title {
      border-bottom: 1px solid #ccc;
      padding: 10px;
    }
    .checked-value {
      padding: 10px;
    }
  }
}

</style>